import { RouteFactory } from "@app/routePaths";
import logoBudget2026 from "@assets/logo-budget-2026-2.png";
import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { useWindowSize } from "@hooks/useWindowSize";

/** This component displays a banner for the Singapore Budget 2026. */
const Budget2026Banner = (): React.ReactElement => {
  const { isScreenLG } = useWindowSize();

  return (
    <div
      data-testid="budget-2026-banner-component"
      className="no-print my-12 rounded-lg border border-gray-175 bg-white px-6 py-8 shadow-[0px_4px_32px_0px_rgba(0,0,0,0.05)] lg:-mx-8"
    >
      <h3 className="mb-6 border-b border-gray-850 pb-2 font-poppins text-lg font-semibold leading-150 tracking-5 text-gray-850">
        MORE ON BUDGET 2026
      </h3>

      <div className="flex items-center gap-5 py-6">
        <img
          src={logoBudget2026}
          alt="Singapore Budget 2026"
          width={88}
          height={100}
        />

        <div>
          <p className="mb-3 font-public-sans text-lg leading-150 tracking-0">
            Visit our Budget 2026 site for more stories and analyses.
          </p>

          {isScreenLG ? (
            <ButtonFactory
              buttonType={ButtonType.Link}
              text="Explore Now"
              mask={ButtonType.Secondary}
              link={RouteFactory.keywordsBudget2026}
              className="inline-block px-9"
            />
          ) : null}
        </div>
      </div>

      {!isScreenLG ? (
        <ButtonFactory
          buttonType={ButtonType.Link}
          text="Explore Now"
          mask={ButtonType.Secondary}
          link={RouteFactory.keywordsBudget2026}
          className="px-9"
        />
      ) : null}
    </div>
  );
};

export default Budget2026Banner;
